import { Link, useLocation } from "react-router-dom";
import "./App.css";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Uled from "./components/ULED";
import Nicer from "./components/Nicer";
import res from "./assets/files/resume.pdf";
import MyWell from "./components/MyWell";
import Greeting from "./components/Greeting";
import Instructor from "./components/Teaching";
import Tabbi from "./components/Tabbi";

const experiences = [
  {
    path: "/tabbi",
    title: "Tabbi",
    description:
      "VP of Engineering at a social fintech startup building mobile payments and real-time tab management.",
    tags: ["React Native", "Expo", "AWS", "GraphQL"],
  },
  {
    path: "/mywell",
    title: "My Well Ministry",
    description:
      "Built the Giving mobile app with Apple Pay, biometric auth, and offline-capable donation flows.",
    tags: ["React Native", "TypeScript", "Node.js"],
  },
  {
    path: "/teaching",
    title: "Teaching Assistant",
    description:
      "Mentored 15+ bootcamp students in React, JavaScript, Python, and Django at Carolina Code School.",
    tags: ["React", "JavaScript", "Python", "Django"],
  },
  {
    path: "/agriculture",
    title: "Agricultural Sales App",
    description:
      "Offline-first React Native sales application for a global agriculture brand with background sync.",
    tags: ["React Native", "Expo", "TypeScript"],
  },
  {
    path: "/uled",
    title: "Universal Ledger",
    description:
      "Freelance project bringing a fintech landing page to life with engaging animations.",
    tags: ["React", "TypeScript"],
  },
];

const App = () => {
  const location = useLocation();
  const path = location.pathname;

  if (path === "/resume") {
    return (
      <div className="Resume">
        <iframe src={res} title="Resume"></iframe>
      </div>
    );
  }

  const isDetail = path !== "/";
  const detailComponents: Record<string, JSX.Element> = {
    "/tabbi": <Tabbi />,
    "/mywell": <MyWell />,
    "/teaching": <Instructor />,
    "/uled": <Uled />,
    "/agriculture": <Nicer />,
  };

  return (
    <div className="App">
      <div className="App-header fade-in">
        <Header />

        <div className="content-container">
          {!isDetail && <Greeting />}

          {isDetail && detailComponents[path]}

          {!isDetail && (
            <div>
              <div className="cards-section-title">Experience</div>
              <div className="cards-grid">
                {experiences.map((exp) => (
                  <Link
                    key={exp.path}
                    to={exp.path}
                    className="card"
                  >
                    <div className="card-title">{exp.title}</div>
                    <div className="card-description">{exp.description}</div>
                    <div className="card-tags">
                      {exp.tags.map((tag) => (
                        <span key={tag} className="card-tag">
                          {tag}
                        </span>
                      ))}
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          )}

          {isDetail && (
            <Link to="/" className="link" style={{ marginTop: 16 }}>
              <span style={{ color: "#666", fontSize: 14 }}>&larr; Back</span>
            </Link>
          )}
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default App;
